import { IconButton } from '@adsk/alloy-react-button';
import Checkbox from '@adsk/alloy-react-checkbox';
import ContentLoader from '@adsk/alloy-react-content-loader';
import { MoreVerticalIcon } from '@adsk/alloy-react-icon';
import ContextMenu from '@adsk/nirvana-context-menu';
import EllipsisText from '@adsk/nirvana-ellipsis-text';
import { styled, colors, margins, boolean, css, paddings } from '@adsk/nirvana-theme';

import InlineEditor from '../InlineEditor';

export const Menu = styled(ContextMenu)`
  z-index: 10;
`;

export const MenuIcon = styled(IconButton).attrs({ size: 24, renderIcon: MoreVerticalIcon.renderIcon })`
  color: transparent;
  margin-left: ${margins.xxSmall};
  margin-right: ${margins.medium};

  &:hover {
    color: ${colors.blue};
  }

  ${boolean(
    'hidden',
    css`
      visibility: hidden;
    `
  )}
`;

export const TreeNode = styled.div`
  display: flex;
  align-items: center;
  flex: auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 100%;

  &:hover {
    & + ${MenuIcon} {
      color: ${colors.charcoal700};
    }
  }
`;

export const NodeLabel = styled(EllipsisText)`
  flex: auto;
`;

export const TooltipNodeLabel = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const InputEditor = styled(InlineEditor)`
  margin-right: 10px;
`;

export const StyledFolderItemCheckbox = styled(Checkbox)`
  margin: 0 ${margins.xSmall};
  background-color: ${(props) => props.disabled && colors.charcoal050};

  input {
    pointer-events: auto;
  }
`;

export const StyledFolderItem = styled.div<{ $disabled?: boolean }>`
  flex: auto;
  display: flex;
  align-items: center;
  overflow: hidden;
  cursor: ${(props) => props.$disabled && 'not-allowed'};
`;

export const ContentLoading = styled(ContentLoader)`
  width: 100%;
  height: 100%;
  padding: ${paddings.large};
`;
